module.exports = __webpack_public_path__ + "img/back01.95708669.jpg";